import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';

const WorkExperience = () => {
  const experiences = [
    {
      title: "Software Engineer",
      company: "Barclays",
      period: "June 2025 - Present",
      description: [],
      skills: []
    },
    {
      title: "Technology Developer Summer Intern",
      company: "Barclays",
      period: "June 2024 - Aug 2024",
      description: [
          "Developed a full-stack group-wide system using React TypeScript, Java Spring Boot, PostgreSQL, Gitlab DevOps and Docker.",
          "Proactively engaged with global stakeholders and senior engineers across all five business areas to iteratively refine requirements and align with long-term strategies.",
          "Reinforced leadership and strong interpersonal skills through team collaboration."
      ],
      skills: ["React", "TypeScript", "Java", "Spring Boot", "PostgreSQL", "GitLab", "Docker", "Agile"]
    },
    {
      title: "Level 5 Referee",
      company: "The FA",
      period: "July 2019 - Present",
      description: [
        "Developed a critical, decisive and impartial mindset by officiating semi-professional football across the South of England.",
        "Coordinate referees across all Universities and Colleges in Bath.",
        "Created Python scripts to automate the referee appointment process.",
        "Mentor and train junior referees."
      ],
      skills: ["Leadership", "Python", "Mentoring", "Coordination", "Automation"]
    }
  ];

  return (
    <Container className="py-5">
      <h1 className="pb-2 mb-4">
        <i className="bi bi-briefcase-fill"></i> Work Experience
      </h1>
      <Row>
        <Col>
          {experiences.map((exp, index) => (
            <Card key={index} className="mb-4 shadow-sm">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <h5 className="mb-1 fw-bold text-primary">{exp.title}</h5>
                    <h6 className="text-muted">{exp.company}</h6>
                  </div>
                  <Badge bg="dark" text="light" className="p-2">{exp.period}</Badge>
                </div>
                {exp.description && exp.description.length > 0 &&
                  <ul className="text-dark mt-3">
                    {exp.description.map((point, i) => (
                      <li key={i}><small>{point}</small></li>
                    ))}
                  </ul>
                }
                <div className="mt-3">
                  {exp.skills.map((skill, skillIndex) => (
                    <Badge key={skillIndex} pill bg="success" className="me-1 mb-1">
                      {skill}
                    </Badge>
                  ))}
                </div>
              </Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default WorkExperience; 